module.exports = __webpack_public_path__ + "img/windy.2c2949c0.svg";